let imchargelist1 = [
  { title: "Length (M)", label: "length" },
  { title: "Width (M)", label: "width" },
  { title: "Height (M)", label: "height" },
  { title: "Ch. Weight (KG)", label: "weight" },
];
export default imchargelist1;
